import { Box, CardMedia, Divider, Grid, Typography } from "@mui/material";

import low_battery_icon from "@/assets/icons/troubleshooting/low-battery.svg";
import useResponsive from "@/hooks/useResponsive";

import { Content, SectionLinks } from "./components/Content";
import Section from "../Section";
import Socials from "./components/Socials";
import SubscriptionForm from "./components/SubscriptionForm";
import { iconStyles, imageWrapperStyles } from "./styles";

const Article = () => {
  const isDesktop = useResponsive("up", "md");

  return (
    <Section
      pt={{ xs: 0, md: 2.5, lg: 7.75 }}
      pb={{ xs: 10, md: 12.5, lg: 30 }}
    >
      <Grid
        container
        columnSpacing={{ xs: 0, md: 4, lg: 10, xl: 11.5 }}
        mb={{ xs: 4, md: 8, lg: 16 }}
      >
        <Grid
          item
          xs={12}
          md={7.5}
          display="flex"
          justifyContent="center"
          flexDirection="column"
        >
          <Typography variant="h1" color="text.primary" mb={{ xs: 2, md: 3 }}>
            Battery draining quickly
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            mb={{ xs: 3, md: 0 }}
          >
            The device battery is depleting faster than expected.
          </Typography>
        </Grid>

        <Grid item xs={12} md={4.5}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={imageWrapperStyles}
          >
            <CardMedia
              component="img"
              image={low_battery_icon}
              alt="battery"
              sx={iconStyles}
            />
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={{ xs: 0, md: 4, lg: 10, xl: 11.5 }}>
        <Grid item xs={12} md={7.5}>
          {!isDesktop && <SectionLinks />}
          <Content />
        </Grid>

        {isDesktop && (
          <Grid item xs={12} md={4.5}>
            <>
              <SectionLinks />
              <SubscriptionForm />
              <Divider sx={{ mb: 4 }} />
              <Socials />
            </>
          </Grid>
        )}
      </Grid>
    </Section>
  );
};

export default Article;
